import { MdbCollapseDirective } from './collapse.directive';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [MdbCollapseDirective],
  exports: [MdbCollapseDirective],
})
export class MdbCollapseModule {}
